module.exports = __webpack_public_path__ + "img/SA3610 & SA3410.3d066803.png";